import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Picture } from 'ui-kit/picture'
import DocumentationMachineImage1x from './builder-documentation-machine@1x.png'
import DocumentationMachineImage2x from './builder-documentation-machine@2x.png'
import DocumentationCodeImage1x from './builder-documentation-code@1x.png'
import DocumentationCodeImage2x from './builder-documentation-code@2x.png'
import DocumentationCodeBgImage1x from './builder-documentation-code-bg@1x.png'
import DocumentationCodeBgImage2x from './builder-documentation-code-bg@2x.png'
import ArrowTopIcon from './icon-arrow-top.svg'
import ArrowBottomIcon from './icon-arrow-bottom.svg'
import AiIcon from './icon-ai.svg'
import clsx from 'clsx'
import classes from './BuilderDocumentation.module.scss'

export const BuilderDocumentation = () => {
  return (
    <Block variant={'solid'} r={'md'} className={classes.content}>
      <Heading as={'h3'} size={'xl'} center balance className={classes.title}>
        Connect to any third-party app on behalf of your customer
      </Heading>
      <Text size={'lg'} center balance className={classes.subtitle}>
        We leverage Al and our unique integration framework to help you
        integrate with any app that has an API.
      </Text>
      <div className={classes.transfer}>
        <div className={classes.wrapper}>
          <Text as={'span'} size={'sm'} center className={classes.desc}>
            Human-readable API Documentation
          </Text>
          <div className={classes.code}>
            <div className={clsx(classes.picture, classes.picture__codeImage)}>
              <Picture
                src1x={DocumentationCodeImage1x.src}
                src2x={DocumentationCodeImage2x.src}
                noBreakpoint={true}
                lazyLoad
                width={386}
                height={492}
                alt='API Documentation'
              />
            </div>
            <div className={clsx(classes.picture, classes.picture__codeBg)}>
              <Picture
                src1x={DocumentationCodeBgImage1x.src}
                src2x={DocumentationCodeBgImage2x.src}
                noBreakpoint={true}
                lazyLoad
                width={386}
                height={492}
                alt='API Documentation'
                aria-hidden='true'
              />
            </div>
          </div>
        </div>
        <div className={classes.box}>
          <div className={classes.processing}>
            <img
              src={ArrowTopIcon.src}
              width={149}
              height={32}
              alt='Top Arrow Icon'
              loading='lazy'
              className={clsx(classes.topArrow, classes.topArrow__right)}
            />
            <img
              src={AiIcon.src}
              alt='AI Icon'
              width={80}
              height={80}
              loading='lazy'
              className={classes.icon}
            />
            <img
              src={ArrowBottomIcon.src}
              width={149}
              height={32}
              loading='lazy'
              alt='Bottom Arrow Icon'
              className={clsx(classes.bottomArrow, classes.bottomArrow__left)}
            />
          </div>
        </div>
        <div className={classes.wrapper}>
          <Text as={'span'} size={'sm'} center className={classes.desc}>
            Machine-readable API Specification
          </Text>
          <div className={clsx(classes.picture, classes.picture__machine)}>
            <Picture
              src1x={DocumentationMachineImage1x.src}
              src2x={DocumentationMachineImage2x.src}
              noBreakpoint={true}
              lazyLoad
              width={400}
              height={540}
              alt='API Specification'
            />
          </div>
        </div>
      </div>
    </Block>
  )
}
